import GuideTeaser from './GuideTeaser';

export default GuideTeaser;
